const AssociateRequestInfo = ({
  icon,
  details,
}: {
  icon: React.ReactNode;
  details: React.ReactNode;
}) => {
  // rendering associate request info component here
  return (
    <div className='flex justify-center md:justify-start items-center gap-1 text-sm text-center md:text-left text-base-dark-blue'>
      {icon}
      <p>{details}</p>
    </div>
  );
};

export default AssociateRequestInfo;
